// @flow
import { toggleCollapse } from 'javascripts/utils/collapse';
import { t } from 'javascripts/utils/withTranslation';
import { initCommentPreview } from './comment-preview-init';

document
  .querySelectorAll('.js-comment-preview')
  .forEach(($trigger) => initCommentPreview($trigger));

document.querySelectorAll('.js-toggle-comment-search').forEach(($toggle) => {
  $toggle?.addEventListener('click', (event) => {
    toggleCollapse($toggle, {
      toggleClass: 'icon-link',
      toggleTextClass: 'icon-link__text',
      closeIcon: '#icon-close',
      openIcon: '#icon-search',
    });
  });
});

/**
 * Opens all comments in the comment list.
 */
export function openAllComments() {
  const $comments = document.querySelectorAll('.comment');
  $comments.forEach(($comment) => {
    // yes we know its the wrong way round, but keep this for backward compatibility
    $comment.classList.add('comment--collapsed');
  });
}

export default openAllComments;
